export function localizedPublicPath(path: string, language: string): string {
  if (!language.startsWith("fr")) return path;
  if (path === "/") return "/fr";
  if (path === "/pricing") return "/fr/pricing";
  if (path === "/learn") return "/fr/learn";
  return path;
}

export function publicLanguageLinks(path: "/" | "/pricing") {
  const english = `https://systematlas.fr${path === "/" ? "" : path}`;
  const french = `https://systematlas.fr${localizedPublicPath(path, "fr")}`;
  return [
    { rel: "alternate", hrefLang: "en", href: english },
    { rel: "alternate", hrefLang: "fr", href: french },
    { rel: "alternate", hrefLang: "x-default", href: english },
  ];
}

export function homeMetadata(language: "en" | "fr") {
  return language === "fr"
    ? {
        title: "System Atlas : fiches de révision et quiz IA",
        description: "Importez vos cours en PDF, notes ou slides et obtenez des fiches de révision structurées, des quiz et un plan de révision. L'assistant d'étude des étudiants.",
      }
    : {
        title: "System Atlas - AI Study Assistant & Revision Sheets",
        description: "Upload your courses and get structured revision sheets, auto-generated quizzes, and spaced repetition. Study and practice directly from your own materials with System Atlas.",
      };
}

export function homeHead(language: "en" | "fr") {
  const { title, description } = homeMetadata(language);
  const url = `https://systematlas.fr${language === "fr" ? "/fr" : ""}`;
  return {
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { property: "og:locale", content: language === "fr" ? "fr_FR" : "en_US" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
    links: [{ rel: "canonical", href: url }, ...publicLanguageLinks("/")],
  };
}